<script type="text/javascript">
  import VLazyImage from "v-lazy-image/v2";

  export default {
    props: [
      'item',
      'progress',
      'bgcolor',
      'titlecolor',
      'textcolor',
    ],
    components: { VLazyImage },
    data() {
      return {

      }
    },
    created() {

    },
    methods: {

    }
  }
</script>

<template>
  <div class="card ribbon-box" :class="bgcolor ? 'bg-'+bgcolor : ''">
    <div class="position-relative _f-shadow-0-1-2-b-4">
      <v-lazy-image v-if="item.thumbnail" :src="formatImage(item.thumbnail)" class="card-img-top img-fluid" :alt="(item.Address+' '+item.City+' '+item.StateOrProvince+' '+item.PostalCode).replace(/[^a-z0-9 ]/gi,'')"></v-lazy-image>
      <img v-else :src="'https://maps.googleapis.com/maps/api/streetview?size=640x480&location='+eurl(item.Latitude+','+item.Longitude)+'&pitch=10&key='+google_key" class="card-img-top img-fluid" :alt="(item.Address+' '+item.City+' '+item.StateOrProvince+' '+item.PostalCode).replace(/[^a-z0-9 ]/gi,'')">
      <div class="position-absolute _pos-l-0 _pos-r-0 _pos-t-0 px-2 py-2 text-white">
        <span class="badge text-white px-2 py-1 mr-2" :class="
          ['Awaiting Order','Awaiting Forms','Awaiting Photos','Awaiting Signatures','Awaiting Listing','Coming Soon'].includes(item.StandardStatus) ? 'badge-warning' :
          ['Active'].includes(item.StandardStatus) ? 'badge-success' :
          ['Active Under Contract','Pending','Delete','Expired','Hold','Incomplete','Withdrawn','Canceled','Closed'].includes(item.StandardStatus) ? 'badge-info' :
          ['Trash'].includes(item.StandardStatus) ? 'badge-danger' : ''
        ">{{item.StandardStatus}}</span>
        <span class="badge badge-danger text-white px-2 py-1 mr-2" v-if="moment(item.OriginalEntryTimestamp).isSameOrAfter(moment().subtract(1, 'week'))">New</span>
        <span class="badge badge-info text-white px-2 py-1 mr-2" v-if="item.PropertyType == 'Land or Lot'">{{item.PropertyType}}</span>
        <span class="badge badge-info text-white px-2 py-1 mr-2" v-if="item.PropertyType == 'Multiple Dwelling'">{{item.PropertyType}}</span>
        <span v-if="item.PhotosCount" class="float-right"><Icon icon="ri:camera-line" />{{item.PhotosCount}}</span>
      </div>
      <div class="position-absolute _pos-l-0 _pos-r-0 _pos-b-0 px-2 py-2">
        <h3 class="m-0 text-white">{{formatPrice(item.ClosePrice ? item.ClosePrice : item.ListPrice, true, false)}}</h3>
      </div>
    </div>
    <div class="card-body p-3 position-relative">
      <h5 class="card-title m-0" :class="titlecolor ? 'text-'+titlecolor : 'text-dark'">{{item.Address}}</h5>
      <p class="small m-0" :class="textcolor ? 'text-'+textcolor : 'text-muted'">{{item.City}} {{item.StateOrProvince}} {{item.PostalCode}}</p>
    </div>
    <div v-if="progress == true" class="card-footer py-4 position-relative" :class="bgcolor ? 'bg-'+bgcolor : 'bg-white'">
      <div class="progress _h-10">
        <div class="progress-bar progress-bar-striped progress-bar-animated" :class="[
          'Delete',
          'Expired',
          'Hold',
          'Withdrawn',
          'Canceled',
          'Closed',
          'Trash',
          'Coming Soon',
          'Incomplete',
          'Active',
          'Active Under Contract',
          'Pending',
        ].includes(item.StandardStatus) ? 'bg-success' : 'bg-warning'"
          :style="[
            'Delete',
            'Expired',
            'Hold',
            'Withdrawn',
            'Canceled',
            'Closed',
            'Trash',
          ].includes(item.StandardStatus) ? 'width:100%' : [
            'Coming Soon',
            'Incomplete',
            'Active',
            'Active Under Contract',
            'Pending',
          ].includes(item.StandardStatus) ? 'width:66%' : [
            'Awaiting Order',
            'Awaiting Forms',
            'Awaiting Photos',
            'Awaiting Signatures',
            'Awaiting Listing',
          ].includes(item.StandardStatus) ? 'width:33%' : 'width:0%'"
        ></div>
      </div>
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 overflow-hidden">
        <div class="row p-3 _f-s-20 _lh-20 _m-l-n-13p _m-r-n-13p">
          <div class="col-3 p-0 text-center"><span class="d-inline-block rounded-circle _w-25 _h-25 _lh-17 border _b-s-3 text-white"
            :class="[
              'Delete',
              'Expired',
              'Hold',
              'Withdrawn',
              'Canceled',
              'Closed',
              'Trash',
              'Coming Soon',
              'Incomplete',
              'Active',
              'Active Under Contract',
              'Pending',
            ].includes(item.StandardStatus) ? 'bg-success border-success' : 'bg-warning border-warning'" v-tippy content="Submit your listing"><Icon icon="ri:check-fill" /></span></div>
          <div class="col-3 p-0 text-center"><span class="d-inline-block rounded-circle _w-25 _h-25 _lh-17 border _b-s-3"
            :class="[
              'Delete',
              'Expired',
              'Hold',
              'Withdrawn',
              'Canceled',
              'Closed',
              'Trash',
              'Coming Soon',
              'Incomplete',
              'Active',
              'Active Under Contract',
              'Pending',
            ].includes(item.StandardStatus) ? 'bg-success border-success text-white' : item.StandardStatus != 'Awaiting Order' ? 'bg-warning border-warning text-white' : 'bg-white text-light'" v-tippy content="Enter property details"><Icon icon="ri:check-fill" /></span></div>
          <div class="col-3 p-0 text-center"><span class="d-inline-block rounded-circle _w-25 _h-25 _lh-17 border _b-s-3"
            :class="[
              'Delete',
              'Expired',
              'Hold',
              'Withdrawn',
              'Canceled',
              'Closed',
              'Trash',
              'Coming Soon',
              'Incomplete',
              'Active',
              'Active Under Contract',
              'Pending',
            ].includes(item.StandardStatus) ? 'bg-success border-success text-white' : 'bg-white text-light'" v-tippy content="Listing is live"><Icon icon="ri:check-fill" /></span></div>
          <div class="col-3 p-0 text-center"><span class="d-inline-block rounded-circle _w-25 _h-25 _lh-17 border _b-s-3"
            :class="[
              'Delete',
              'Expired',
              'Hold',
              'Withdrawn',
              'Canceled',
              'Closed',
              'Trash',
            ].includes(item.StandardStatus) ? 'bg-success border-success text-white' : 'bg-white text-light'" v-tippy content="Listing is complete"><Icon icon="ri:check-fill" /></span></div>
        </div>
      </div>
    </div>
    <div v-else class="card-footer p-2 position-relative text-muted small" :class="'bg-'+(bgcolor ? bgcolor : 'white')">
      <span class="card-link text-nowrap small mr-3 ml-0" v-if="item.BedroomsTotal > 0"><Icon icon="ri:hotel-bed-line" /> Beds : {{parseFloat(item.BedroomsTotal)}}</span>
      <span class="card-link text-nowrap small mr-3 ml-0" v-if="item.BathroomsTotalInteger > 0"><Icon icon="ri:contrast-drop-line" /> Baths : {{parseFloat(item.BathroomsTotalInteger)}}</span>
      <span class="card-link text-nowrap small mr-3 ml-0" v-if="item.LivingArea > 0"><Icon icon="ri:ruler-2-line" /> SQFT : {{parseFloat(item.LivingArea)}}</span>
      <span class="card-link text-nowrap small mr-3 ml-0" v-if="item.LotSizeAcres > 0"><Icon icon="ri:pencil-ruler-line" /> Acres : {{parseFloat(item.LotSizeAcres)}}</span>
      <span v-if="item.PropertyType == 'Multiple Dwelling' && item.UnitNumber" class="card-link text-nowrap small"><Icon icon="ri:hotel-bed-line" /> Units : {{item.UnitNumber}}</span>
    </div>
  </div>
</template>
